module.exports = __webpack_public_path__ + "static/media/under-review-status.e02f370a.svg";